// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VE_nrEy9r8Kk47WvRnCk{height:100%;margin-bottom:16px;position:relative}.iumg3UERKrohUbc4b1ol{flex-direction:column;height:100%;display:flex;overflow-x:scroll}.pM6LFa572R4ibatXi79T{z-index:var(--zIndex-BASE_2);position:absolute;top:24px;right:20px}.VC2mUvjFG4_Ujshvkq5b{flex-direction:column;flex-grow:1;width:1032px;margin:0 auto;padding:0 20px;display:flex}@media (max-width:992px){.VC2mUvjFG4_Ujshvkq5b{width:668px}}@media (min-width:992px){.VC2mUvjFG4_Ujshvkq5b{width:858px}}@media (min-width:1200px){.VC2mUvjFG4_Ujshvkq5b{width:1065px}}@media (min-width:1440px){.VC2mUvjFG4_Ujshvkq5b{width:1072px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `VE_nrEy9r8Kk47WvRnCk`,
	"container": `iumg3UERKrohUbc4b1ol`,
	"closeIconWrapper": `pM6LFa572R4ibatXi79T`,
	"content": `VC2mUvjFG4_Ujshvkq5b`
};
export default ___CSS_LOADER_EXPORT___;
